(function (window) {
  'use strict';

  // Shows/hides form groups as toggle controls within the form are selected.
  function handleRadioChange(e) {
    const form = e.target.closest('.js-checkout-form');

    if (form) {
      hideFormGroups(form);
    }
  }

  // Some form item groups should only be exposed if a particular toggle
  // control is selected. These are shown on initial page load for anyone
  // without JS.
  function hideFormGroups(form) {
    const itemGroups = form.querySelectorAll('.js-checkout-form-item-group');

    for (let i = 0; i < itemGroups.length; i++) {
      const itemGroupToggleId = itemGroups[i].getAttribute('data-toggle-id');
      const reverseToggle = itemGroups[i].getAttribute('data-reverse-toggle') === 'true';
      const toggle = document.getElementById(itemGroupToggleId);

      if (itemGroupToggleId && toggle) {
        if ((toggle.checked && !reverseToggle) || (!toggle.checked && reverseToggle)) {
          itemGroups[i].classList.remove('js-hidden');
        }
        else {
          itemGroups[i].classList.add('js-hidden');
        }
      }
    }
  }

  function initForm(form) {
    const toggles = form.querySelectorAll('.radio, .checkbox');

    hideFormGroups(form);

    for (let i = 0; i < toggles.length; i++) {
      toggles[i].addEventListener('change', handleRadioChange);
    }
  }

  function init() {
    const forms = document.querySelectorAll('.js-checkout-form');

    for (let i = 0; i < forms.length; i++) {
      if (!forms[i].classList.contains('js-component-init')) {
        initForm(forms[i]);

        forms[i].classList.add('js-component-init');
      }
    }
  }

  // Allow application JS to reinitialize any instances added with Ajax, etc.
  if (typeof componentEvents !== 'undefined') {
    componentEvents.on('component-init', init);
  }

  init();

})(this);
